class FacetFiltersForm extends HTMLElement {
    constructor() {
        super();
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

        this.debouncedOnSubmit = debounce((event) => {
            this.onSubmitHandler(event);
        }, 800);

        const facetForm = this.querySelector('form');

        // Cambiamos el evento para los checkboxes
        facetForm.addEventListener('change', (event) => {
            if (event.target.type === 'checkbox') {
                this.debouncedOnSubmit(event);
            }
        });

        // Mantenemos el evento input para otros controles (como el precio)
        facetForm.addEventListener('input', (event) => {
            if (event.target.type !== 'checkbox') {
                this.debouncedOnSubmit(event);
            }
        });

        const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
        if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    }

    static setListeners() {
        const onHistoryChange = (event) => {
            const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
            if (searchParams === FacetFiltersForm.searchParamsPrev) return;
            FacetFiltersForm.renderPage(searchParams, null, false);
        };
        window.addEventListener('popstate', onHistoryChange);
    }

    static toggleActiveFacets(disable = true) {
        document.querySelectorAll('.js-facet-remove').forEach((element) => {
            element.classList.toggle('disabled', disable);
        });
    }

    static renderPage(searchParams, event, updateURLHash = true) {
        // Render page with searchParams
        FacetFiltersForm.searchParamsPrev = searchParams;
        const sections = FacetFiltersForm.getSections();
        const countContainer = document.getElementById('ProductCount');
        const countContainerDesktop = document.getElementById('ProductCountDesktop');
        const loadingSpinners = document.querySelectorAll(
            '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
        );
        loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
        document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
        if (countContainer) {
            countContainer.classList.add('loading');
        }
        if (countContainerDesktop) {
            countContainerDesktop.classList.add('loading');
        }

        sections.forEach((section) => {
            const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
            // Fetching URL
            const filterDataUrl = (element) => element.url === url;

            FacetFiltersForm.filterData.some(filterDataUrl)
                ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
                : FacetFiltersForm.renderSectionFromFetch(url, event);
        });

        if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    }

        static closeMobileFiltersDrawer(event) {
        const isMobileForm = event && event.target && event.target.closest && event.target.closest('form')?.id === 'FacetFiltersFormMobile';
        if (!isMobileForm) return;
        const menuDrawer = document.getElementById('FacetFiltersFormMobile')?.closest('menu-drawer');
        const summary = menuDrawer?.querySelector('details summary');
        if (menuDrawer && typeof menuDrawer.closeMenuDrawer === 'function' && summary) {
            menuDrawer.closeMenuDrawer(new Event('click'), summary);
        }
    }






    static renderSectionFromFetch(url, event) {
        fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
                const html = responseText;
                FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
                FacetFiltersForm.renderFilters(html, event);
                FacetFiltersForm.renderProductGridContainer(html);
                FacetFiltersForm.renderProductCount(html);
                if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
            })
            .then(() => {
                document.dispatchEvent(new CustomEvent('facet:rendered'));
            });
    }

    static renderSectionFromCache(filterDataUrl, event) {
        const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    }

    static renderProductGridContainer(html) {
        document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
            .parseFromString(html, 'text/html')
            .getElementById('ProductGridContainer').innerHTML;

        document
            .getElementById('ProductGridContainer')
            .querySelectorAll('.scroll-trigger')
            .forEach((element) => {
                element.classList.add('scroll-trigger--cancel');
            });

        const collection = document.getElementById('ProductGridContainer')?.querySelector('.collection');
        if (collection) collection.classList.remove('loading');
    }

    static renderProductCount(html) {
        const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
        const container = document.getElementById('ProductCount');
        const containerDesktop = document.getElementById('ProductCountDesktop');
        container.innerHTML = count;
        container.classList.remove('loading');
        if (containerDesktop) {
            containerDesktop.innerHTML = count;
            containerDesktop.classList.remove('loading');
        }
        const loadingSpinners = document.querySelectorAll(
            '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
        );
        loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
    }

    static renderFilters(html, event) {
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
            '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
        );
        const facetDetailsElementsFromDom = document.querySelectorAll(
            '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
        );

        // Remove facets that are no longer returned from the server
        Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
            if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
                currentElement.remove();
            }
        });

        const matchesId = (element) => {
            const jsFilter = event ? event.target.closest('.js-filter') : undefined;
            return jsFilter ? element.id === jsFilter.id : false;
        };

        const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
        const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

        facetsToRender.forEach((elementToRender, index) => {
            const currentElement = document.getElementById(elementToRender.id);
            // Element already rendered in the DOM so just update the innerHTML
            if (currentElement) {
                document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
            } else {
                if (index > 0) {
                    const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
                    // Same facet type (eg horizontal/vertical or drawer/mobile)
                    if (elementToRender.className === previousElementClassName) {
                        document.getElementById(previousElementId).after(elementToRender);
                        return;
                    }
                }

                if (elementToRender.parentElement) {
                    const parentId = elementToRender.parentElement.id;
                    const container = document.getElementById(parentId);

                    const rawIndex = elementToRender.dataset.index || '';
                    const prefixMatch = rawIndex.match(/^([^\d]+)?/);
                    const prefix = prefixMatch ? prefixMatch[0] || '' : '';
                    const cleanedIndex = parseInt(rawIndex.replace(/[^\d]/g, ''), 10);


                    const targetIndex = cleanedIndex;
                    let inserted = false;

                    for (let i = targetIndex - 1; i >= 1; i--) {
                        const selector = `[data-index="${prefix}${i}"]`;
                        const previousSibling = container.querySelector(selector);

                        if (previousSibling) {
                            previousSibling.after(elementToRender);
                            inserted = true;
                            break;
                        }
                    }

                    if (!inserted) {
                        const jsFilter = container.querySelector('.js-filter');
                        if (jsFilter) {
                            jsFilter.before(elementToRender);
                        } else {
                            container.appendChild(elementToRender);
                        }
                    }
                }
            }
        });

        FacetFiltersForm.renderActiveFacets(parsedHTML);
        FacetFiltersForm.renderAdditionalElements(parsedHTML);

        if (countsToRender) {
            const closestJSFilterID = event.target.closest('.js-filter').id;

            if (closestJSFilterID) {
                FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
                FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

                const newFacetDetailsElement = document.getElementById(closestJSFilterID);
                const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
                    ? `.mobile-facets__close-button`
                    : `.facets__summary`;
                const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

                const isTextInput = event.target.getAttribute('type') === 'text';

                if (newElementToActivate && !isTextInput) newElementToActivate.focus();
            }
        }
    }

    static renderActiveFacets(html) {
        const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

        activeFacetElementSelectors.forEach((selector) => {
            const activeFacetsElement = html.querySelector(selector);
            if (!activeFacetsElement) return;
            document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
        });

        FacetFiltersForm.updateActiveFacetsVisibility();
        FacetFiltersForm.toggleActiveFacets(false);
    }

    static updateActiveFacetsVisibility() {
        const selectors = ['.active-facets-mobile', '.active-facets-desktop'];
        selectors.forEach((selector) => {
            const container = document.querySelector(selector);
            if (!container) return;

            // Consider "active" if there is at least one removable facet button (not just the wrapper)
            const hasAnyFacet =
                container.querySelectorAll('.active-facets__button, .active-facets__button--light').length > 0;

            container.classList.toggle('hidden', !hasAnyFacet);
        });
    }

    static renderAdditionalElements(html) {
        const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

        mobileElementSelectors.forEach((selector) => {
            if (!html.querySelector(selector)) return;
            document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
        });

        document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
    }

    static renderCounts(source, target) {
        const targetSummary = target.querySelector('.facets__summary');
        const sourceSummary = source.querySelector('.facets__summary');

        if (sourceSummary && targetSummary) {
            targetSummary.outerHTML = sourceSummary.outerHTML;
        }

        const targetHeaderElement = target.querySelector('.facets__header');
        const sourceHeaderElement = source.querySelector('.facets__header');

        if (sourceHeaderElement && targetHeaderElement) {
            targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
        }

        const targetWrapElement = target.querySelector('.facets-wrap');
        const sourceWrapElement = source.querySelector('.facets-wrap');

        if (sourceWrapElement && targetWrapElement) {
            const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
            if (isShowingMore) {
                sourceWrapElement
                    .querySelectorAll('.facets__item.hidden')
                    .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
            }

            targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
        }
    }

    static renderMobileCounts(source, target) {
        const targetFacetsList = target.querySelector('.mobile-facets__list');
        const sourceFacetsList = source.querySelector('.mobile-facets__list');

        if (sourceFacetsList && targetFacetsList) {
            targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
        }

        target.querySelectorAll('.mobile-facets__submenu show-more-button').forEach((showMore) => {
            showMore.querySelector('.label-show-more')?.classList.remove('hidden');
            showMore.querySelector('.label-show-less')?.classList.add('hidden');
        });
    }

    static updateURLHash(searchParams) {
        // Updating URL hash with params

        // Asegurarnos de que los parámetros son un string
        if (typeof searchParams !== 'string') {
            if (searchParams instanceof URLSearchParams) {
                searchParams = searchParams.toString();
            } else {
                console.error('searchParams is not a string or URLSearchParams');
                return;
            }
        }

        // Actualizar la URL del navegador con los parámetros de búsqueda
        history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    }

    static getSections() {
        return [
            {
                section: document.getElementById('product-grid').dataset.id,
            },
        ];
    }

    createSearchParams(form) {
        const formData = new FormData(form);

        // Convertir FormData a un objeto plano para manipularlo más fácilmente
        const formEntries = {};
        for (let [key, value] of formData.entries()) {
            // Incluir todos los valores, incluso los vacíos
            formEntries[key] = value;
        }

        // Crear un nuevo URLSearchParams con los valores únicos
        const searchParams = new URLSearchParams();

        // Añadir cada entrada una sola vez
        for (const [key, value] of Object.entries(formEntries)) {
            searchParams.set(key, value);
        }

        return searchParams.toString();
    }

    onSubmitForm(searchParams, event) {
        // Asegurar que los parámetros sean un string
        if (searchParams instanceof FormData) {
            searchParams = this.createSearchParams(searchParams);
        }

        // Search params processing
        FacetFiltersForm.renderPage(searchParams, event);
    }

    onSubmitHandler(event) {
        event.preventDefault();
        // Submit handler triggered

        // Determinar si estamos en la versión móvil
        const currentForm = event.target.closest('form');
        const fd = new FormData(currentForm);
        const triggeredSortBy = fd.get('sort_by');

        const isMobile = currentForm && currentForm.id === 'FacetFiltersFormMobile';

        // Objeto para mantener los parámetros acumulados
        // Usamos un objeto para cada clave de filtro para permitir múltiples valores
        const accumulatedParams = {};

        // Obtener todos los formularios de filtros
        const sortFilterForms = document.querySelectorAll('facet-filters-form form');

        // Crear el string de parámetros
        const searchParams = new URLSearchParams();

        if (event.srcElement && event.srcElement.className == 'mobile-facets__checkboxassss') {
            const searchParams = this.createSearchParams(event.target.closest('form'));
            this.onSubmitForm(searchParams, event);
        } else {
            // Objeto para acumular todos los parámetros de los formularios
            const allParams = {};
            const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

            // Procesar cada formulario relevante
            sortFilterForms.forEach((form) => {
                const isRelevantForm =
                    (!isMobile && (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm')) ||
                    (isMobile && (form.id === 'FacetFiltersFormMobile' || form.id === 'FacetSortForm' || form.id === 'FacetSortDrawerForm'));

                if (isRelevantForm) {
                    // Extraer datos de cada formulario
                    const formData = new FormData(form);
                    for (let [key, value] of formData.entries()) {
                        // Si ya existe la clave, acumulamos en array
                        if (allParams[key]) {
                            if (!Array.isArray(allParams[key])) {
                                allParams[key] = [allParams[key]];
                            }
                            allParams[key].push(value);
                        } else {
                            allParams[key] = value;
                        }
                    }
                }
            });

            for (const [key, value] of Object.entries(allParams)) {
                if (Array.isArray(value)) {
                    const cleanKey = key.replace(/\[\]$/, '');
                    if (cleanKey === 'sort_by') {
                        searchParams.set(cleanKey, triggeredSortBy || allParams['sort_by'][0]);
                    } else {
                        searchParams.set(cleanKey, value.join(','));
                    }
                } else {
                    const cleanKey = key.replace(/\[\]$/, '');
                    searchParams.set(cleanKey, value);
                }
            }
            this.onSubmitForm(searchParams.toString(), event);
        }
    }

    onActiveFilterClick(event) {
        event.preventDefault();
        FacetFiltersForm.toggleActiveFacets();
        const url =
            event.currentTarget.href.indexOf('?') == -1
                ? ''
                : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
        FacetFiltersForm.renderPage(url);
    }
}

// Función para ocultar opciones sin productos
FacetFiltersForm.hideEmptyOptions = function() {
    // Seleccionar todos los items de filtro
    const facetItems = document.querySelectorAll('.facets__item, .mobile-facets__item');

    facetItems.forEach(item => {
        // Buscar el contador de productos en el elemento
        const countText = item.querySelector('.visually-hidden')?.textContent || '';
        // Buscar si el elemento está marcado como activo
        const isActive = item.querySelector('input[type="checkbox"]:checked');

        // Extraer el número del contador (ej: "Talla 17 (0)" -> 0)
        const countMatch = countText.match(/\((\d+)\)/);

        if (countMatch && parseInt(countMatch[1]) === 0 && !isActive) {
            // Si el contador es 0 y no está activo, ocultar el elemento
            item.style.display = 'none';
        }
    });
};

// Inicializar datos y registrar el componente
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

// Ejecutar la función para ocultar opciones sin productos cuando la página carga
document.addEventListener('DOMContentLoaded', function() {
    FacetFiltersForm.hideEmptyOptions();
    FacetFiltersForm.updateActiveFacetsVisibility();
});

// También ejecutar después de renderizar los filtros
document.addEventListener('facet:rendered', function() {
    FacetFiltersForm.hideEmptyOptions();
    FacetFiltersForm.updateActiveFacetsVisibility();
});

class PriceRange extends HTMLElement {
    constructor() {
        super();
        this.querySelectorAll('input').forEach((element) => {
            element.addEventListener('change', this.onRangeChange.bind(this));
            element.addEventListener('keydown', this.onKeyDown.bind(this));
        });
        this.setMinAndMaxValues();
    }

    onRangeChange(event) {
        this.adjustToValidValues(event.currentTarget);
        this.setMinAndMaxValues();
    }

    onKeyDown(event) {
        if (event.metaKey) return;

        const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
        if (!event.key.match(pattern)) event.preventDefault();
    }

    setMinAndMaxValues() {
        const inputs = this.querySelectorAll('input');
        const minInput = inputs[0];
        const maxInput = inputs[1];
        if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
        if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
        if (minInput.value === '') maxInput.setAttribute('data-min', 0);
        if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
    }

    adjustToValidValues(input) {
        const value = Number(input.value);
        const min = Number(input.getAttribute('data-min'));
        const max = Number(input.getAttribute('data-max'));

        if (value < min) input.value = min;
        if (value > max) input.value = max;
    }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
    constructor() {
        super();
        const facetLink = this.querySelector('a');
        facetLink.setAttribute('role', 'button');
        facetLink.addEventListener('click', this.closeFilter.bind(this));
        facetLink.addEventListener('keyup', (event) => {
            event.preventDefault();
            if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
        });
    }

    closeFilter(event) {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
    }
}

customElements.define('facet-remove', FacetRemove);